module.exports = __webpack_public_path__ + "img/DSC6081.cda1fbb5.jpg";